/**
 * What to call someone who hasn't set a display name.
 *
 * Three forms because position decides the wording: a byline or heading
 * ("Anonymous"), the subject at the start of a sentence ("This cook hasn't
 * shared any recipes yet"), and the same subject mid-sentence ("a snapshot of
 * this cook's food personality"). Keeping them together is what stops each
 * surface from inventing its own — the app had "User", "Anonymous" and "This
 * user" all standing for the same person.
 */

/** Byline or heading: stands where a name would stand. */
export const ownerDisplayName = (displayName?: string): string =>
  displayName?.trim() || 'Anonymous';

/** Subject of a sentence that starts with it. */
export const ownerSentenceSubject = (displayName?: string): string =>
  displayName?.trim() || 'This cook';

/** Same subject, appearing partway through a sentence. */
export const ownerMidSentence = (displayName?: string): string =>
  displayName?.trim() || 'this cook';
